import React from 'react'

const ProgressForm = ({PageNumber}) => {
  return (
    <div className='mt-6 mb-6 flex justify-center items-center form__section'>
    <p style={{width:"2rem",height:"2rem", flex:"0 0 2rem", lineHeight:"28px"}} className={`flex justify-center border-2 rounded-full ${PageNumber === 1 ? "text-[#0F8491] border-[#0F8491]" : "text-white bg-[#0F8491] border-gray"}`}>
    1
    </p>
    <hr style={{width:"9rem"}} className='bg-gray mx-4'/>
    <p style={{width:"2rem",height:"2rem", flex:"0 0 2rem", lineHeight:"28px"}} className={`flex justify-center border-2 rounded-full ${PageNumber === 2 ? "text-[#0F8491] border-[#0F8491]" : "text-white bg-[#0F8491] border-gray"}`}>2</p>
    <hr style={{width:"9rem"}} className='bg-gray mx-4'/>
    <p style={{width:"2rem",height:"2rem", flex:"0 0 2rem", lineHeight:"28px"}} className={`flex justify-center border-2 rounded-full ${PageNumber === 3 ? "text-[#0F8491] border-[#0F8491]" : "text-white bg-[#0F8491] border-gray"}`}>3</p>
    <hr style={{width:"9rem"}} className='bg-gray mx-4'/>
    <p style={{width:"2rem",height:"2rem", flex:"0 0 2rem", lineHeight:"28px"}} className={`flex justify-center border-2 rounded-full ${PageNumber === 4 ? "text-[#0F8491] border-[#0F8491]" : "text-white bg-[#0F8491] border-gray"}`}>4</p>
    {/* <hr style={{width:"9rem"}} className='bg-gray mx-4'/> */}
    {/* <p style={{width:"2rem",height:"2rem", flex:"0 0 2rem", lineHeight:"28px"}} className={`flex justify-center border-2 rounded-full ${PageNumber === 5 ? "text-[#0F8491] border-[#0F8491]" : "text-white bg-[#0F8491] border-gray"}`}>5</p> */}
  </div>
  )
}

export default ProgressForm
